import './tile.sass';

export { default } from './tile';
